import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";
import { pHelpURLs } from "../../utils/parameters";
import Grid from "@mui/material/Grid";

import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import LSE_icon from "../../assets/icons/LSE_icon30.jpeg"
import Contact_Email from "../../assets/icons/mail-message.png"
import Contact_Message from "../../assets/icons/message.png"
import { useTranslation } from "react-i18next";

import "../../styles/devices/mob_HelpDialog.css";

export function HelpDialog(props) {
  const { openDialog, setOpenDialog } = props;
  const { t } = useTranslation("global")

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog className="sig_Drawer_SettingsModal_Root" open={openDialog} onClose={handleClose}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title">
        {t("sHelpForm.helpForm_title").toUpperCase()}
      </DialogTitle>
      <DialogContent className="sig_Drawer_SettingsModal_Content">
        <div className="sig_HelpModal_Intro" style={{lineHeight: '2'}}>
        {/* <div className="sig_HelpModal_Intro"> */}
          <p> {t("sHelpForm.helpForm_body")} </p>
          <p style={{lineHeight: '2'}}>
          {t("sHelpForm.notice_send_request_part1")}  <img src={LSE_icon} style={{ maxWidth: '20px', maxHeight: '20px', marginRight: '4px' }} /> {t("sHelpForm.notice_send_request_part2")} <span style={{ textDecoration: 'underline', color: '#9fc5e8'}}><Link href={pHelpURLs.form_help} underline="hover" target="_blank"> {t("strButton.link")} </Link></span>.
        </p>
        </div>
        <br></br>

        <Paper className="sig_HelpModal_PaperContent">
          <div className="sig_HelpModal_PaperTitle"> {t("sHelpForm.helpForm_subtitle")} </div>
          <hr></hr>
          <div className="sig_HelpModal_PaperBody">
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Link className="sig_HelpModal_Button" component="button" variant="body2" onClick={handleClickOpenURL(pHelpURLs.signamed)}>
                  {t("sHelpForm.signamed")}
                </Link>
              </Grid>
              <Grid item>
                <Link className="sig_HelpModal_Button" component="button" variant="body2" onClick={handleClickOpenURL(pHelpURLs.tecnologia)}>
                  {t("sHelpForm.tecnology")}
                </Link>
              </Grid>
              <Grid item>
                <Link className="sig_HelpModal_Button" component="button" variant="body2" onClick={handleClickOpenURL(pHelpURLs.funcionalidad)}>
                  {t("sHelpForm.functionality")}
                </Link>
              </Grid>
              <Grid item>
                <Link className="sig_HelpModal_Button" component="button" variant="body2" onClick={handleClickOpenURL(pHelpURLs.terminos_uso)}>
                  {t("sHelpForm.term_of_use")}
                </Link>
              </Grid>
              <Grid item>
                <Link className="sig_HelpModal_Button" component="button" variant="body2" onClick={handleClickOpenURL(pHelpURLs.privacidad)}>
                  {t("sHelpForm.privacy")}
                </Link>
              </Grid>
            </Grid>
          </div>
        </Paper>
        <DialogActions className="sig_FormDialog_Button">
          <Button onClick={handleClose}> {t("strButton.btn_exit")} </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
